import { getSelectioAxios } from '@/main';


export default class CountryService {

    getCountries() {
        return getSelectioAxios().get('/uber/anagrafica/countries')
            .then(result => result.data);
    }
}
